export { FormRender } from './FormRender'
export { FormRender as default } from './FormRender'

export type {
  FormRenderProps,
  CurrentSchema,
  JsonSchemaResult,
  JSONContent,
  EditorLayout,
  FieldSettings,
} from './types'

export {
  splitContentByPages,
  compileCurrentSchema,
  getFieldNameByFieldId,
  convertStylesToSx,
  parseStyleString,
  collectConditions,
  buildCompiledJsonSchema,
} from './utils'

export { buildFormTheme } from './theme'

export const defaultStylesForButtons = {
  submit: {
    variant: 'filled',
    backgroundColor: '#0BD68D',
    color: '#FFFFFF',
  },
  next: {
    variant: 'filled',
    backgroundColor: '#014ee6',
    color: '#FFFFFF',
  },
}
